function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import tasks from '@/js/tasks';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['customer_insights']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/customer_insights';
var DOMAIN_CONFIGURATION = '/configuration';
var DOMAIN_REGIONS = '/regions';
var DOMAIN_SECTIONS = '/sections';
var DOMAIN_UPDATE_HOURS = '/update_hours';
export default {
  getInitialData: function getInitialData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION, "/get_initial_data"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getUsers: function getUsers() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION, "/get_users"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  addRegion: function addRegion() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_REGIONS, "/add"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  deleteRegion: function deleteRegion() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    var region = 'r';
    console.log(body);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_REGIONS, "/").concat(region, "/delete"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  getUpdateHours: function getUpdateHours() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_UPDATE_HOURS, "/get_all"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  addUpdateHour: function addUpdateHour() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_UPDATE_HOURS, "/add"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  addSection: function addSection() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_SECTIONS, "/add"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  deleteSection: function deleteSection(section) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_SECTIONS, "/").concat(section, "/delete"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  // addUser(data = {}) {
  //   const login = loginObj()
  //   const body = { login, ...data }
  //   tasks.lockScreen.lock()
  //   return appApisGTW.post(`${CONTROLLER_NAME}${DOMAIN_CONFIGURATION}${DOMAIN_SECTIONS}/add`, body).then(response => {
  //     tasks.lockScreen.unlock()
  //     return response.data
  //   })
  // },
  // deleteUser(user, data = {}) {
  //   const login = loginObj()
  //   const body = { login, ...data }
  //   tasks.lockScreen.lock()
  //   return appApisGTW.post(`${CONTROLLER_NAME}${DOMAIN_CONFIGURATION}${DOMAIN_SECTIONS}/${user}/delete`, body).then(response => {
  //     tasks.lockScreen.unlock()
  //     return response.data
  //   })
  // },
  editUpdateHour: function editUpdateHour(updateHourId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_UPDATE_HOURS, "/").concat(updateHourId, "/edit"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  deleteUpdateHour: function deleteUpdateHour(updateHourId) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_CONFIGURATION).concat(DOMAIN_UPDATE_HOURS, "/").concat(updateHourId, "/delete"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  migrateApplicant: function migrateApplicant() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/migration/migrate_applicant"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      tasks.lockScreen.unlock();
      throw err;
    });
  }
};